<template>
  <div>
    <div class="livechat-girl animated" @click="onOnlineService">
      <img class="girl" src="@/assets/icon_ask@2.png">
      <!-- <img class="girl" src="@/assets/service.png">
        <div class="livechat-hint rd-notice-tooltip rd-notice-type-success rd-notice-position-left single-line show_hint">
        <div class="rd-notice-content">
          <div style="font-size: 18px;font-weight: 500;line-height: 35px;">Need Help?</div>
          <div>Click here and start </div>
          <div>chatting with us!</div>
        </div>
      </div>
      <div :class="['animated-circles',classSelect?'animated':'']">
        <div class="circle c-1" />
        <div class="circle c-2" />
        <div class="circle c-3" />
      </div> -->
    </div>
    <div v-show="onlineShow" class="sdk-frame" style="width: 375px; height: 600px; right: 10px; bottom: 10px;z-index: 999999;">
      <div class="sdk-frame-tl" style="height: 64px; line-height: 64px; background-color: rgb(76, 126, 233);">
        <span id="frame-title-id-0F094F1C475C6E91B49612E55DA0EAD7">Online Service</span>
        <a href="javascript:;" title="Close" style="top: 21px;" @click="onCloseOnline">^</a>
      </div>
      <div class="sdk-frame-cont" style="top: 64px;">
        <iframe :src="serviceUrl" allow="microphone" style="width: 100%; height: 100%; border: none;" />
      </div>
    </div>
  </div>
</template>
<script>
import { initBrowserVersion } from '@/utils/browserVersion'
export default {
  name: 'OnlineService',
  data() {
    return {
      onlineShow: false,
      classSelect: false,
      defaultServiceUrl: '',
      serviceUrl: '',
      timer: null
    }
  },
  created() {
    const browserVersion = initBrowserVersion() || {}
    this.defaultServiceUrl = `https://u-gygj.instadesk.com/dzfront/web/home?token=EziEbu3qeMVz&showChat=true&side=mobile&device=PC&browser=${browserVersion.browser}&browserVersion=${browserVersion.version}&language=zh_CN&screen_width=1440&screen_height=900&title=TopReap%20Portal&current_url=${encodeURIComponent(window.location.href)}&current_host=${encodeURIComponent(window.location.host)}&mode=mobile&jssdkFlag=true&name=${encodeURIComponent('new friend')}`
    this.serviceUrl = this.defaultServiceUrl
  },
  mounted() {
    this.onStartService()
  },
  beforeDestroy() {
    clearInterval(this.timer)
  },
  methods: {
    onStartService() {
      this.timer = setInterval(() => {
        if (this.classSelect) {
          this.classSelect = false
        } else {
          this.classSelect = true
        }
      }, 3000)
    },
    onOnlineService() {
      clearInterval(this.timer)
      this.onlineShow = true
    },
    onCloseOnline() {
      this.onStartService()
      this.onlineShow = false
    }
  }
}
</script>

<style lang="scss" scoped>
@keyframes scaleToggleOne {
  0% {
    transform:scale(1);
    -webkit-transform:scale(1)
  }
  50% {
    transform:scale(2);
    -webkit-transform:scale(2)
  }
  100% {
    transform:scale(1);
    -webkit-transform:scale(1)
  }
}
@keyframes scaleToggleTwo { 0% {
transform:scale(1);
-webkit-transform:scale(1)
}
20% {
transform:scale(1);
-webkit-transform:scale(1)
}
60% {
transform:scale(2);
-webkit-transform:scale(2)
}
100% {
transform:scale(1);
-webkit-transform:scale(1)
}
}
@keyframes scaleToggleThree { 0% {
transform:scale(1);
-webkit-transform:scale(1)
}
33% {
transform:scale(1);
-webkit-transform:scale(1)
}
66% {
transform:scale(2);
-webkit-transform:scale(2)
}
100% {
transform:scale(1);
-webkit-transform:scale(1)
}
}
  .animated { -webkit-animation-duration: .5s; animation-duration: .5s; -webkit-animation-fill-mode: both; animation-fill-mode: both }
.livechat-girl { width: 60px; height: 60px; border-radius: 50%; position: fixed; bottom: 0; right: 20px; opacity: 0; -webkit-box-shadow: 0 5px 10px 0 rgba(35,50,56,.3); box-shadow: 0 5px 10px 0 rgba(35,50,56,.3); z-index: 700; transform: translateY(0); -webkit-transform: translateY(0); -ms-transform: translateY(0); cursor: pointer; -webkit-transition: all 1s cubic-bezier(.86, 0, .07, 1); transition: all 1s cubic-bezier(.86, 0, .07, 1) }
.livechat-girl:focus { outline: 0 }
.livechat-girl.animated { opacity: 1; transform: translateY(-40px); -webkit-transform: translateY(-40px); -ms-transform: translateY(-40px) }
// .livechat-girl:after { content: ''; width: 12px; height: 12px; border-radius: 50%; background-image: linear-gradient(to bottom, #26c7fc, #26c7fc); position: absolute; right: 1px; top: 1px; z-index: 50 }
.livechat-girl .girl { position: absolute; top: 0; left: 0; width: 100%; height: auto; z-index: 50 }
.livechat-girl .girl:hover { transform: scale(1.1) }
.livechat-girl .animated-circles .circle { background: rgba(38,199,252,.25); width: 60px; height: 60px; border-radius: 50%; position: absolute; z-index: 49; transform: scale(1); -webkit-transform: scale(1) }
.livechat-girl .animated-circles.animated .c-1 { animation: 2s scaleToggleOne cubic-bezier(.25, .46, .45, .94) forwards }
.livechat-girl .animated-circles.animated .c-2 { animation: 2.5s scaleToggleTwo cubic-bezier(.25, .46, .45, .94) forwards }
.livechat-girl .animated-circles.animated .c-3 { animation: 3s scaleToggleThree cubic-bezier(.25, .46, .45, .94) forwards }
.livechat-girl.animation-stopped .circle { opacity: 0!important }
.livechat-girl.animation-stopped .circle { opacity: 0!important }
.livechat-girl .livechat-hint { position: absolute; margin-top: -98px; opacity: 0; z-index: 0; -webkit-transition: all .3s cubic-bezier(.86, 0, .07, 1); transition: all .3s cubic-bezier(.86, 0, .07, 1) }
.livechat-girl .livechat-hint.show_hint { -webkit-transform: translateX(-40px); transform: translateX(-40px); opacity: 1 }
.livechat-girl .livechat-hint.hide_hint { opacity: 0; -webkit-transform: translateX(0); transform: translateX(0) }
.livechat-girl .livechat-hint.rd-notice-tooltip { max-width: 1296px!important }
.livechat-girl .livechat-hint.rd-notice-tooltip .rd-notice-content { width: auto; overflow: hidden; text-overflow: ellipsis }
@media only screen and (max-width:1599px) {
.livechat-girl .livechat-hint.rd-notice-tooltip { max-width: 1060px!important }
}
@media only screen and (max-width:1309px) {
.livechat-girl .livechat-hint.rd-notice-tooltip { max-width: 984px!important }
}
@media only screen and (max-width:1124px) {
.livechat-girl .livechat-hint.rd-notice-tooltip { max-width: 600px!important }
}
.rd-notice-tooltip { -webkit-box-shadow: 0 2px 2px rgba(0,0,0,.2); box-shadow: 0 2px 2px rgba(0,0,0,.2); font-size: 14px; border-radius: 3px; line-height: 1.25; position: absolute; z-index: 65; max-width: 350px; opacity: 1 }
.rd-notice-tooltip:after { position: absolute; display: block; content: ''; height: 20px; width: 20px; -webkit-box-shadow: none; box-shadow: none; -webkit-transform: rotate(-45deg); -moz-transform: rotate(-45deg); -ms-transform: rotate(-45deg); -o-transform: rotate(-45deg); transform: rotate(-45deg); -webkit-border-radius: 3px; -moz-border-radius: 3px; border-radius: 3px; z-index: 50 }
.rd-notice-tooltip .rd-notice-content { background: 0; border-radius: 3px; width: 100%; color: #fff; position: relative; z-index: 60; padding: 20px; font-weight: 400; line-height: 1.45 }
.rd-notice-type-success { background-color: #26c7fc; -webkit-box-shadow: 0 5px 10px 0 rgba(38,199,252,.2); box-shadow: 0 5px 10px 0 rgba(38,199,252,.2) }
.rd-notice-type-success .rd-notice-content { background-color: #26c7fc }
.rd-notice-type-success:after { background-color: #26c7fc; -webkit-box-shadow: 0 5px 10px 0 rgba(38,199,252,.2); box-shadow: 0 5px 10px 0 rgba(38,199,252,.2) }
.rd-notice-position-left { margin-left: -30px }
.rd-notice-position-left:after { right: 25%; margin-top: -11px }
.rd-notice-tooltip.single-line .rd-notice-content { padding: 5px 10px; white-space: nowrap }
.sdk-frame {
    position: fixed;
    bottom: 10px;
    width: 375px;
    height: 600px;
    bottom: 10px;
    display: flex;
    flex-direction: column;
    border: 1px solid #dcdfe6;
}
.sdk-frame-tl {
    position: relative;
    height: 64px;
    line-height: 64px;
    color: #fff;
    font-size: 18px;
    padding: 0 17px;
    background-color: #4c7ee9;
    span {
    font-size: 16px;
    }
    a {
    position: absolute;
    right: 17px;
    top: 21px;
    width: 20px;
    height: 20px;
    color: #fff;
    line-height: 25px;
    border-radius: 50%;
    text-align: center;
    display: inline-block;
    text-decoration: none;
    transform: rotate(180deg);
    border: 1px solid #fff;
}
}
.sdk-frame-cont {
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    right: 0;
    background-color: #fff;
}
</style>
